module.exports = __webpack_public_path__ + "img/create-wallet.41248cce.png";